import { Typography } from '@/components/primitives/Typography';
import type { LegDTO } from '@/types/dto/agent';
import { cn } from '@/utils/cn';
import { formatDuration, formatTime } from '@/utils/dateTime';
import type { FC } from 'react';

interface TripDetailsProps {
  leg: LegDTO;
  className?: string;
}

const TripDetails: FC<TripDetailsProps> = ({ leg, className }) => {
  return (
    <div className={cn('w-full', className)}>
      <div className={'flex w-full items-center gap-3'}>
        <Typography variant="times" asChild>
          <h2>{formatTime(leg.departureTime)}</h2>
        </Typography>
        <div
          className={cn(
            'flex h-1/2 w-fit flex-1 items-center gap-0.5 self-center text-neutral'
          )}
        >
          <div className="w-5 flex-1 border-b border-neutral" />
          <Typography variant="caption" className="whitespace-nowrap">
            {formatDuration(leg.duration)}
          </Typography>
          <div className="w-5 flex-1 border-b border-neutral" />
        </div>
        <Typography variant="times" asChild>
          <h2>{formatTime(leg.arrivalTime)}</h2>
        </Typography>
      </div>
      <div className="flex w-full justify-between">
        <Typography variant="body2">{leg.originStop?.name}</Typography>
        <Typography variant="body2">{leg.destinationStop?.name}</Typography>
      </div>
    </div>
  );
};

export default TripDetails;
